// extracted by mini-css-extract-plugin
export default {"container":"FileIcon_container__tp5Ut"};